import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'
import { useFilterBarStyles } from '../FilterBar.styles'
import SearchIcon from '../../icons/SearchIcon'

type FilterSearchFieldProps = {
    onInputChange: (value: string) => void
}

export const FilterSearchField = ({
    onInputChange
}: FilterSearchFieldProps) => {
    const { t } = useTranslation('filter')
    const styles = useFilterBarStyles()

    return (
        <TextField
            id="compounds-filter-input"
            onChange={(e) => onInputChange(e.target.value)}
            className={styles.textField}
            placeholder={t('filter.inputPlaceholder')}
            InputProps={{
                endAdornment: (
                    <SearchIcon className={styles.iconStyle} fontSize="small" />
                )
            }}
        />
    )
}

export default FilterSearchField
